'use strict';

var _ = require('lodash');
var JQXGridSettingsService = function JQXGridSettingsService() {
  function resetFilterAndSorting(gridSettings) {
    if (gridSettings && gridSettings.jqxGrid && _.isFunction(gridSettings.jqxGrid)) {
      gridSettings.jqxGrid('clearfilters');
      gridSettings.jqxGrid('removesort');
    }
  }
  return {
    resetFilterAndSorting: resetFilterAndSorting
  };
};
JQXGridSettingsService.$inject = [];
module.exports = JQXGridSettingsService;